import { createSelector } from 'reselect';
import { selectCurrentProfileUserProfileName } from '../Users/CurrentProfileUser/selectors';

const profilePageSelector = (state) => state.ProfilePage;

// Select the user who's profile page or subpages are currently being viewed
export const selectCurrentlyViewProfilePage = createSelector(
  profilePageSelector,
  selectCurrentProfileUserProfileName,
  (profilePage, profileName) => {
    return profilePage.getIn(['byProfileName', profileName]);
  }
);

export const selectCurrentlyViewProfilePageIsDirty = createSelector(
  selectCurrentlyViewProfilePage,
  (currentProfilePage) => {
    return currentProfilePage
      ? currentProfilePage.get('pageDirty', false)
      : false;
  }
);

export const selectUnsavedWarningCallback = createSelector(
  profilePageSelector,
  (ProfilePage) => {
    return ProfilePage.get('warningCallback', null);
  }
);
